import React from "react";
import { Box, Button, Chip, Stack } from "@mui/material";

const QueryActiveFilterChips = ({ chips = [], onDismiss, onClearAll }) => {
  if (!chips.length) return null;

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{ mb: 2, overflowX: "auto", pb: 0.5 }}
    >
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", flex: 1 }}>
        {chips.map((chip) => (
          <Chip
            key={chip.key}
            label={chip.label}
            onDelete={() => onDismiss(chip.key)}
            size="small"
            sx={{ fontWeight: 700 }}
          />
        ))}
      </Box>
      <Button size="small" onClick={onClearAll} sx={{ flexShrink: 0 }}>
        Clear all
      </Button>
    </Stack>
  );
};

export default QueryActiveFilterChips;
